import { mustBeFilled } from '../../libs/validators';

export const inputEncounterdProblemConfig = {
  label: 'Problème rencontré',
  name: 'encounteredProblem',
  validators: {
    format: [],
    submit: mustBeFilled('Veuillez sélectionner le problème rencontré'),
  },
};
